export default __webpack_public_path__ + "static/media/aero-comfort.9254a585.jpg";